import { AType } from "@silversea-ssc/functional-support"
import { PriceResponseV2 } from "../price"

export const FarePriceResponse = PriceResponseV2
export type FarePriceResponse = AType<typeof FarePriceResponse>
